"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Checkbox_1 = require("../../checkbox/Checkbox");
const RowItem_1 = __importDefault(require("../rowItem/RowItem"));
const RowCheckboxItem = ({ checkboxSelection, value }) => {
    const { checked, toggleChecked, disabled } = checkboxSelection;
    const onSingleCheckboxToggle = (record) => {
        if (!checked.some(({ id }) => id === record.id)) {
            toggleChecked([...checked, record]);
        }
        else {
            toggleChecked(checked.filter(({ id }) => record.id !== id));
        }
    };
    const isChecked = checked.some(({ id }) => id === value.id);
    return ((0, jsx_runtime_1.jsx)(RowItem_1.default, { children: (0, jsx_runtime_1.jsx)(Checkbox_1.Checkbox, { onClick: (e) => e.stopPropagation(), onChange: () => onSingleCheckboxToggle(value), checked: isChecked, disabled: !!disabled }) }));
};
// eslint-disable-next-line import/no-default-export
exports.default = RowCheckboxItem;
